// extracted by mini-css-extract-plugin
module.exports = {"backdrop-1":"ModalButton_backdrop-1__1Zf1Q","dialog-1":"ModalButton_dialog-1__1IqjC"};